import React from 'react';
import { Badge, Button } from '@ncoder/ui';

interface VersionItemProps {
  version: string;
  description: string;
  isCurrent?: boolean;
  onAction?: () => void;
  actionLabel?: string;
}

export const VersionItem: React.FC<VersionItemProps> = ({
  version,
  description,
  isCurrent = false,
  onAction,
  actionLabel = 'Deploy',
}) => {
  return (
    <div className="flex items-center justify-between p-3 border rounded">
      <div className="min-w-0">
        <p className="font-medium">{version}</p>
        <p className="text-sm text-muted-foreground truncate">{description}</p>
      </div>
      {isCurrent ? (
        <Badge variant="default">Current</Badge>
      ) : (
        <Button variant="outline" size="sm" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </div>
  );
};
